// extracted by mini-css-extract-plugin
export default {"Switch":"styles_Switch__9WAdQ","SwitchActive":"styles_SwitchActive__njSbd","Dial":"styles_Dial__70kvu"};